module.exports = __webpack_public_path__ + "images/fontello.woff";


//////////////////
// WEBPACK FOOTER
// ./~/mavon-editor/dist/font/fontello.woff
// module id = 948
// module chunks = 2